import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import PropTypes from 'prop-types';

import './Logo.scss';
import Pages from '../../Context/Pages';
import Link from '../Link/Link'

import LogoSymbol from '../../Assets/logo-symbol.svg'
import LogoText from '../../Assets/logo-text.png'

class Logo extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  getImage(className, source) {
    const { size } = this.props;

    return (
      <Link
        className='no-select'
        page={Pages.Home}
      >
        <img
          className={`logo-image ${className}`}
          src={source}
          style={className === 'logo-symbol' ? { height: size, width: size } : null}
          alt=''
        />
      </Link>
    );
  }

  render() {
    const { type, size } = this.props;
    return (
      <div
        className='logo-container'
        style={{ height: size }}
      >
        {this.getImage('logo-symbol', LogoSymbol)}
        {type === 'Expanded' &&
          <div className='logo-text-container'>
            {this.getImage('logo-text', LogoText)}
          </div>
        }
      </div>
    );
  }
}

Logo.propTypes = {
  type: PropTypes.oneOf(['Expanded', 'Small']),
  size: PropTypes.number
};

Logo.defaultProps = {
  type: 'Expanded',
  size: 60
}

Logo.contextType = GraingerAccountContext;
export default Logo;